import { render, staticRenderFns } from "./CurrentTags.vue?vue&type=template&id=79859de8&scoped=true&"
import script from "./CurrentTags.vue?vue&type=script&lang=ts&"
export * from "./CurrentTags.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentTags.vue?vue&type=style&index=0&id=79859de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79859de8",
  null
  
)

export default component.exports